import User from '../User';
import { meApi } from '@/scripts/webcall/v3/me';
import { FetchUserFnReturnType } from '../Authenticator';

export const fetchUserFn = async(): Promise<FetchUserFnReturnType> => {
  try {
    const { data } = await meApi.profile.show();
    return {
      user: new User(data),
      error: null,
    };
  } catch (error) {
    return {
      user: null,
      error,
    };
  }
};
